import { render, staticRenderFns } from "./MenuFloat.vue?vue&type=template&id=68d7a3f2&"
import script from "./MenuFloat.vue?vue&type=script&lang=js&"
export * from "./MenuFloat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports